export const validateQuestion = (type, answers) => {
    if (type !== 3 && answers?.length < 2) {
        return 'tests.answerError';
    }
    if ((type === 1 || type === 2) && !answers?.some(({ isCorrect }) => isCorrect)) {
        return 'tests.isCorrectError';
    }
    return null;
};
